import React from "react";
import SidbarComponent from "../SidbarComponent";
import TopBarComponent from "../TopBarComponent";
import { FooterComponents } from "../FooterComponent";

/**
 * Shared page chrome for the Administration screens (same structure as
 * AdminUserManagement): top bar, sidebar, page header, content, footer.
 */
export default function AdminLayout({ title, subtitle, icon: Icon, actions, children }) {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <TopBarComponent />
      <div className="flex flex-1">
        <SidbarComponent />

        <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">
          <div className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                {Icon && <Icon className="w-7 h-7 text-cyan-600" />}
                {title}
              </h1>
              {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
          </div>

          {children}
        </main>
      </div>

      <FooterComponents />
    </div>
  );
}

/** Small stat tile used at the top of the admin pages. */
export function StatCard({ icon: Icon, value, label, tone = "cyan" }) {
  const tones = {
    cyan: "text-cyan-600",
    amber: "text-amber-500",
    green: "text-green-600",
    gray: "text-gray-500",
  };
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      {Icon && (
        <div className={`${tones[tone] || tones.cyan} mb-3`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
      <p className="text-2xl font-bold text-gray-900">{value}</p>
      <p className="text-xs font-medium mt-1 text-gray-500">{label}</p>
    </div>
  );
}

/** Active / inactive pill for entities that carry a numeric `state`. */
export function StateBadge({ state }) {
  const active = state === 1 || state === undefined || state === null;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${
        active
          ? "bg-green-50 text-green-700 border-green-200"
          : "bg-gray-100 text-gray-600 border-gray-200"
      }`}
    >
      {active ? "Active" : "Inactive"}
    </span>
  );
}
